import AgGridWrapper from "../../../../../components/AgGridWrapper/AgGridWrapper";
import ActionButtons from "../../../../../components/ActionButtons";
import { changeStatus, setGrid } from "../../utils/slice";
import { useAppSelector } from "../../../../../utils/hooks/hooks";
import ConfirmModal from "../../../../../components/Modals/ConfirmModal";
import { useState } from "react";
import useColumnDefs from "./columnDefs";
import { RootState } from "../../../../../store/app";
import React from "react";

const Listing: React.FC<any> = ({
  moduleInfo,
  handleViewClick,
  handleDeleteClick,
  handleEditClick,
}) => {
  const columnDefs = useColumnDefs;
  const experience = useAppSelector((state: RootState) => state.experience);
  const [statusData, setStatusData] = useState<any>();

  const ActionRenderer = (props: any) => {
    return (
      <ActionButtons
        data={props}
        view={{
          action: handleViewClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
        }}
        edit={{
          action: handleEditClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_UPDATE`,
        }}
        deleteButton={{
          action: handleDeleteClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DELETE`,
        }}
      />
    );
  };

  return (
    <>
      <ConfirmModal
        titleName={moduleInfo.title}
        data={statusData}
        close={() => setStatusData(null)}
        callApi={changeStatus}
      />
      <AgGridWrapper
        components={{
          ActionRenderer,
        }}
        rowData={experience.rowData}
        onGridReadyWithDispatch={setGrid}
        columnDefs={columnDefs}
        context={{ setStatusData }}
        paginationPageSize={experience.perPage}
        cacheBlockSize={experience.perPage}
      />
    </>
  );
};

export default Listing;
